module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[98]97.6ce580b.woff2";